import React, { useState, useCallback } from 'react';
import { Collapsible, RichText } from '@printdeal/ui-library';
import { Markdown } from '@printdeal/markdown/react';

interface Props {
  title: string;
  content?: {
    content: string;
  };
  handleClick?: ({ title, open }: { title: string; open: boolean }) => void;
}

const noop = () => {};

const Content = ({ title, content, handleClick = noop }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClick = useCallback(() => {
    setIsOpen((prevOpen) => !prevOpen);
    handleClick({ title, open: !isOpen });
  }, [handleClick, isOpen, title]);

  if (!content) {
    return null;
  }

  return (
    <article className="pd-py-3">
      <Collapsible variant="secondary" id={title}>
        <Collapsible.Header
          button={<Collapsible.Button onClick={onClick} />}
          title={title}
        />
        <Collapsible.Panel unmount={false}>
          <RichText as={Markdown} anchorTarget="_blank">{content.content}</RichText>
        </Collapsible.Panel>
      </Collapsible>
    </article>
  );
};

export default Content;
